import { Injectable } from '@angular/core';
import { AppConfigService } from './appConfigService';
import { HttpClient } from '@angular/common/http';
import { UserDetails } from '../model/DocumentTemplate';
import { Observable } from 'rxjs';
import { UpdateKpiUserMappingViewModel, UserKpiMasterViewModel } from '../model/KPI/user-kpi-master-view-model';
import { KpiMaster } from '../model/KPI/kpi-master';

@Injectable({
  providedIn: 'root'
})
export class KpiService {
  APIEndPoint: string;
  IntegrationAPIEndPoint: string;
  constructor(private environment: AppConfigService, private http: HttpClient) {
    this.IntegrationAPIEndPoint = environment.config.DATA.API_END_POINT.INTEGRATION_API_URL;
    this.APIEndPoint = this.environment.config.DATA.API_END_POINT.API_URL;
  }
  getKpiUserMapping(userDetails: UserDetails): Observable<UserKpiMasterViewModel[]> {
    return this.http.post<UserKpiMasterViewModel[]>(this.APIEndPoint + '/Kpi/GetKpiUserMapping', userDetails);
  }
  getEngagementKpiDashboardDataByUser(userDetails: UserDetails): Observable<KpiMaster[]> {
    return this.http.post<KpiMaster[]>(this.APIEndPoint + '/Kpi/GetEngagementKpiDashboardDataByUser', userDetails);
  }
  updateKpiUserMapping(updateKpiUserMappingViewModel: UpdateKpiUserMappingViewModel): Observable<string> {
    return this.http.post(this.APIEndPoint + '/Kpi/UpdateKpiUserMapping', updateKpiUserMappingViewModel, { responseType: 'text' });
  }
}
